import { Pipe, PipeTransform } from '@angular/core';
import {formatTwoDigitString, formatMonthString} from './../helpers/helpers'

@Pipe({
  name: 'dateconvert',
  pure : false
})
export class DateConvertPipe implements PipeTransform {

  transform(datestring): string {
    if(!datestring) return '';
    
    let currentDate = new Date(datestring.split("+")[0]);
    return formatTwoDigitString(currentDate.getDate()) + ' ' + formatMonthString(currentDate.getMonth()) + ' ' + currentDate.getFullYear() + ' ' + formatTwoDigitString(currentDate.getHours()) + ':' + formatTwoDigitString(currentDate.getMinutes()) + ':' + formatTwoDigitString(currentDate.getSeconds()) + ' UTC';
   }
}